/* eslint-disable no-case-declarations */
import {
  CREATE_SIGNAL_FORM_CLEAR,
  CREATE_SIGNAL_FORM_EDIT,
  CREATE_SIGNAL_FORM_ERROR,
  CREATE_SIGNAL_FORM_REQUEST,
} from '../../../constants/ActionTypes';

function getDefaultdata() {
  return {
    type: 'tv_strategy',
    maxEntryCount: 1,
  };
}

const createSignal = (
  state = {
    data: getDefaultdata(),
    updatedAt: new Date(),
    error: {},
  },
  action
) => {
  switch (action.type) {
    case CREATE_SIGNAL_FORM_EDIT:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.data,
        },
        updatedAt: new Date(),
      };
    case CREATE_SIGNAL_FORM_CLEAR:
      return {
        ...state,
        data: getDefaultdata(),
        updatedAt: new Date(),
      };
    case CREATE_SIGNAL_FORM_REQUEST:
      return {
        ...state,
        error: {},
      };
    case CREATE_SIGNAL_FORM_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

export default createSignal;
